<template>
  <o-form-group :id="this_id" :form-state="formState" :label="label">
    <b-button-group>
      <b-button
        :style="{ color: btn.color }"
        v-for="btn in buttons"
        :key="btn.id"
        @click="click(btn.id)"
        :variant="getVariant(btn, btn.id == value)"
      >
        <check-box-outline-icon v-if="btn.id == value" />
        {{ btn.textField }}
      </b-button>
    </b-button-group>
  </o-form-group>
</template>

<script>
import _ from "lodash";
import { filter_active_list } from "@/vue-ocom/utils/active.js";
import CheckBoxOutlineIcon from "vue-material-design-icons/CheckBoxOutline.vue";

export default {
  name: "OGroupButton",
  components: {
    CheckBoxOutlineIcon,
  },
  model: {
    prop: "value",
    event: "input",
  },
  data() {
    return {
      search: "",
    };
  },
  created() {
    console.log("created", this.items);
  },
  props: {
    id: { type: String, required: true },
    label: { type: String, default: null },
    validators: { type: Object, default: () => null },
    level: { type: Number, default: 0 },
    validator: { type: Object, default: null },
    formState: { type: Object, default: null },
    items: { type: Array, default: null },
    value: { type: Boolean },
    textField: { type: String, default: "description" },
    quickDisplayOrderField: {
      type: String,
      default: "quick_display_order",
    },
    disableMore: { type: Boolean, default: false },
    maxMoreItems: { type: Number, default: 10 },
  },
  methods: {
    click(btnID) {
      if (this.validator) {
        this.validator.$touch();
      }
      if (this.formState) this.formState.dirty = true;

      this.$emit("input", btnID);
    },
    getVariant(btn, val) {
      var values = {
        false: "outline-dark",
        true: btn.id ? "success" : "danger",
      };
      return values[val];
    },
  },
  computed: {
    buttons() {
      const vm = this;
      return this.items;
    },
    all_other_buttons() {
      const vm = this;

      return _.sortBy(
        _.filter(filter_active_list(this.items), function (o) {
          if (vm.quickDisplayOrderField) {
            return !o[vm.quickDisplayOrderField];
          } else {
            return false; // no extras
          }
        }),
        this.textField
      );
    },
    other_buttons() {
      var items = this.all_other_buttons;
      const vm = this;

      // Filter by search
      items = _.filter(items, function (o) {
        return o[vm.textField].includes(vm.search);
      });

      return _.slice(items, 0, vm.maxMoreItems);
    },
  },
};
</script>

<style scoped></style>
